export default __webpack_public_path__ + "static/en-027501d382a98eca49dedef7a2050841.png";